import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import firebase from '@/scripts/firebase';
import store from '@/store';
import axios from '@/plugins/axios';

// Extras
var VueScrollTo = require('vue-scrollto');

// External JS.
require('../src/scripts/herohire');

// Extra Directives
Vue.use(VueScrollTo, {
  container: "body",
  duration: 1000,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.config.productionTip = false;

Vue.prototype.$firebase = firebase
Vue.prototype.$braintreeFunctions = axios.braintreeApi
const $user = {}

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
  data: {
    $user
  }
}).$mount('#app');
